<template>
  <div class="flex flex-col">
    <div class="flex h-[54px] items-center gap-[10px] bg-[--v3-input-lists-inputlistheaderbg] px-[12px] py-[8px] text-[--v3-global-textsecondarycolor]">
      <div class="flex size-[14px] cursor-pointer items-center justify-center" @click="$emit('return')">
        <Icon name="angle-left" class="h-[12px] w-[7px] text-[--v3-surface-surface-900]" />
      </div>
      <span class="v3-body-regular-400-line-height-auto">New List</span>
    </div>
    <div class="bg-[--v3-input-field-inputbg] px-[12px] py-[30px]">
      <InputText
        v-model="listName"
        :disabled="creating"
        class="w-full"
        @keydown.enter.prevent="handleCreate"
      />
    </div>
    <div class="flex h-[66px] gap-[18px] bg-[--v3-input-lists-inputlistitemhoverbg] px-[12px] py-[14px]">
      <Button
        label="Cancel"
        outlined
        class="flex-1"
        :disabled="creating"
        @click="$emit('return')"
      />
      <Button
        :disabled="listName.length === 0"
        :loading="creating"
        class="flex-1"
        icon-class="size-[14px]"
        icon="check"
        label="Create"
        @click="handleCreate"
      />
    </div>
    <div />
  </div>
</template>

<script lang="ts" setup>
import InputText from 'primevue/inputtext';
import { ref } from 'vue';

import Button from '@/common/components/atoms/Button';
import Icon from '@/common/components/atoms/Icon';

interface Props {
  creating?: boolean
}

const props = withDefaults(defineProps<Props>(),{
  creating: false,
});

const emit = defineEmits<{
  create: [value: string],
  return: [],
}>();

const listName = ref<string>('');

const handleCreate = () => {
  if (!listName.value.length || props.creating) return;

  emit('create', listName.value);
};
</script>
